import useMountEffect from '@restart/hooks/useMountEffect';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import API from '@/helpers/API';

const useLoadUser = () => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    // API: 계정 조회
    API.get('/accounts').then(({ success, data }) => {
      if (success) {
        dispatch(actions.user.load(data));
      }
    });
  });
};

export default useLoadUser;
